import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";

// Extend dayjs with the quarter plugin
dayjs.extend(quarterOfYear);

// Define the type for the component's props
interface QuarterDropdownProps {
  onSelect: (quarter: {
    label: string;
    startDate: string;
    endDate: string;
  }) => void;
}

// Create a function to generate the last 4 quarters based on NZ financial year
const getFourRecentQuarters = () => {
  const quarters = [];
  let currentDate = dayjs();
  // Adjust the quarter based on NZ financial year (April start)
  // Q1: 1st April - 30th June
  // Q2: 1st July - 30th September
  // Q3: 1st October - 31st December
  // Q4: 1st January - 31st March
  for (let i = 0; i < 8; i++) {
    const startDate = currentDate.subtract(i * 1, "quarter").startOf("quarter");
    const endDate = currentDate.subtract(i * 1, "quarter").endOf("quarter");
    const isInPreviousQuarter = startDate.month() < 3;
    const startYear = isInPreviousQuarter ? startDate.year() - 1 : startDate.year();
    const endYear = isInPreviousQuarter ? endDate.year() : endDate.year() + 1;
    let labelQuarter = startDate.quarter() + 3;
    if (labelQuarter > 4) {
      labelQuarter -= 4;
    }
    quarters.push({
      label: `Q${labelQuarter} ${startYear} - ${endYear}`,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    });
  }
  return quarters;
};

const QuarterDropdown: React.FC<QuarterDropdownProps> = ({ onSelect }) => {
  const quarters = getFourRecentQuarters();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedQuarter = quarters.find(
      (q) => q.label === event.target.value
    );
    if (selectedQuarter) {
      onSelect(selectedQuarter);
    }
  };

  return (
    <Form.Group controlId="quarterSelect">
      <Form.Label>Quarter</Form.Label>
      <Form.Select onChange={handleChange} defaultValue={quarters[0].label}>
        <option value="" disabled>
          Select a quarter...
        </option>
        {quarters.map((quarter, index) => (
          <option key={index} value={quarter.label}>
            {quarter.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default QuarterDropdown;
